import { Pipe } from "@angular/core";
import { Status, StatusColor } from "../../models/folder.model";

@Pipe({
    name: 'folderStatus',
})
export class FolderStatusPipe {
  transform(value: string, mode = 'title') : string {
    if (!value) return "";

    if (mode === 'title') {
      return Status[value as keyof typeof Status];
    }

    else if (mode === 'color') {
      return StatusColor[value as keyof typeof StatusColor];
    }

    return '';
  }
}
